import { useEffect, useSyncExternalStore } from 'react';
import {
  getPwaInstallState,
  initializePwa,
  promptPwaInstall,
  subscribeToPwaInstall,
} from '../services/pwa';

export const usePwaInstall = () => {
  useEffect(() => {
    initializePwa();
  }, []);

  const state = useSyncExternalStore(
    subscribeToPwaInstall,
    getPwaInstallState,
    getPwaInstallState
  );

  return {
    ...state,
    promptInstall: promptPwaInstall,
  };
};
